/*
semsomi AB
Copyright (c) 2016-2017
All rights reserved
*/
import {
  FEED_REQUEST,
  FEED_SUCCESS,
  FEED_FAILURE,
  ADD_FEED_REQUEST,
  ADD_FEED_SUCCESS,
  ADD_FEED_FAILURE,
  REMOVE_FEED_REQUEST,
  REMOVE_FEED_SUCCESS,
  REMOVE_FEED_FAILURE,
  // SEARCH_REQUEST,
  // SEARCH_SUCCESS,
  // SEARCH_FAILURE,
  UPDATE_MENU,
  REMOVE_FEED,
  SET_FEEDS,
  SET_FEED,
  SET_TABS,
  SET_PUFFS,
  SET_PUFF,
  ORDERPUFF_REQUEST,
  ORDERPUFF_SUCCESS,
  ORDERPUFF_FAILURE
} from './actionTypes'
// import * as types from './actionTypes';
import { CALL_API } from '../middlewares/api'
import {settingsToParams} from '../util';

const firstBatch = {
  map:100,
  magazine:30
}

function feedType(feed){
    if(feed && feed.plugins && feed.plugins.find(p=>p.type==='search')){
      return 'virtual'
    }else if(feed && feed.plugins && feed.plugins.find(p=>p.type==='scrape')){
      return 'scrape'
    }else{
      return null
    }
}



function fetchFeed(feed, offset=0) {
  return (dispatch, getState)=>{
    const state = getState().feeds;
    const feedIndex = state.findIndex(f=>f.id===feed.id);

    if(feedIndex<0 || feed.id==='profile') return

    const {isFetching} = state[feedIndex];
    if(isFetching)return;
    
    let settings = settingsToParams(feed)
    // console.log("feed")
    // console.log(feed)
    let params = {
      q:feed.id,
      // selectionO:feed.selection ? feed.selection : undefined,
      // locationO: feed.location ? feed.location : undefined,
      s:firstBatch[settings.view] && offset<1 ? firstBatch[settings.view] : undefined,
      view:settings.view,
      sort:feed.id==='profile' ? 'created' : (settings.sort ? settings.sort : feed.lastRequest.sort),
      c: settings.category ? [settings.category.toLowerCase()] : undefined,//feed.lastRequest.categories
      product:settings.product,
      f:offset
    }
    


    let endpoint = paramsToEndpoint('feed', params)  

    const previousEndpoint = state[feedIndex].currentRequest ? state[feedIndex].currentRequest.endpoint:null

    // console.log(endpoint)
    // console.log(previousEndpoint)

    if(previousEndpoint===endpoint)return;

    dispatch({
      [CALL_API]: {
        endpoint: endpoint,
        feed:feed,
        offset:offset,
        types: [FEED_REQUEST, FEED_SUCCESS, FEED_FAILURE]
      }
    })
  }
}

function paramsToEndpoint(path, params){
  return path+'/?'+Object.entries(params).filter(p=>p[1]).map(e => e.join('=')).join('&');
}


function search(query, offset=0, feed) {

  return (dispatch, getState)=>{
    const state = getState().feeds;
    const feedIndex = state.findIndex(f=>f.id==feed.id);
    const {isFetching} = state[feedIndex];
    if(isFetching)return;

    let settings = settingsToParams(feed)

    let params = {
      q:query,
      s:firstBatch[settings.view] && offset<1 ? firstBatch[settings.view] : undefined,
      feed:settings.feed,
      view:settings.view,
      sort:(settings.sort ? settings.sort : feed.lastRequest.sort),
      product:settings.product ? settings.product : (feed.product ? feed.product : undefined),
      f:offset
    }
    
    let endpoint = paramsToEndpoint('search', params)

    const previousEndpoint = state[feedIndex].lastRequest ? state[feedIndex].lastRequest.endpoint : null;     

    // console.log("endpoint")
    // console.log(endpoint)
    // console.log("previousEndpoint")
    // console.log(previousEndpoint)

    if(previousEndpoint && offset===null){
      let normEndpoint = (paramsToEndpoint('search', {...params, s:undefined, f:undefined}))
      let normPrevEndpoint = previousEndpoint.split('&f=')[0]

      // console.log("normEndpoint")
      // console.log(normEndpoint)
      // console.log("normPrevEndpoint")
      // console.log(normPrevEndpoint)

      if(normPrevEndpoint===normEndpoint) return;
    }    

    if(previousEndpoint===endpoint) return;

    dispatch({
      [CALL_API]: {
        endpoint: endpoint,
        feed:{...feed, id:feed.id, query:query},
        offset:offset,
        types: [FEED_REQUEST, FEED_SUCCESS, FEED_FAILURE]
      }
    })
  }
}


function addFeed(feed, index) {
  return (dispatch, getState)=>{
    const endpoint = "addfeed"
    const query = feed.query.q
    return dispatch({
      [CALL_API]: {
        endpoint: endpoint,
        feed:feed,
        index: index,
        body:{type:'virtual', prefix:'feed',id:feed.title, name:feed.title, title:feed.title, query:{q:query}, submenu:[]},
        types: [ADD_FEED_REQUEST, ADD_FEED_SUCCESS, ADD_FEED_FAILURE]
      }
    })
  }
}

function addFeedOld(feed, index) {
  return (dispatch, getState)=>{
    const endpoint = "tabs"
    const query = feed.query.q
    return dispatch({
      [CALL_API]: {
        endpoint: endpoint,
        feed:feed,
        index: index,
        body:{title:feed.title, query:query, submenu:[]},
        types: [ADD_FEED_REQUEST, ADD_FEED_SUCCESS, ADD_FEED_FAILURE]
      }
    })
  }
}

function removeFeed(feed, goto) {
  return (dispatch, getState)=>{
    return dispatch({
      [CALL_API]: {
        endpoint: 'removefeed/'+feed.id, //.dbid
        feed:feed,
        goto:goto,
        method:'delete',
        types: [REMOVE_FEED_REQUEST, REMOVE_FEED_SUCCESS, REMOVE_FEED_FAILURE]
      }
    })
  }
}

function setFeed(feed, user) {
  return {
    type: SET_FEED,
    feed:feed,
    user:user
  };
}


function setFeeds(feeds, goto) {
  return {
    type: SET_FEEDS,
    goto:goto,
    feeds:feeds
  };
}

function setTabs(feeds, user=undefined) {
  return {
    type: SET_TABS,
    feeds:feeds,
    user:user
  };
}

function updateMenu(feed, menu) {
  return {
    type: UPDATE_MENU,
    feed: feed,
    menu: menu ? menu : feed.menu
  };
}

function setPuff(feed, puff) {
  return {
    type: SET_PUFF,
    feed: feed,
    puff: puff
  };
}

function setPuffs(feed,puffs) {
  return {
    type: SET_PUFFS,
    feed: feed,
    puffs: puffs
  };
}


module.exports={
  search,
  fetchFeed,
  addFeed,
  removeFeed,
  setFeeds,
  setFeed,
  setTabs,
  setPuffs,
  setPuff,
  updateMenu
}